// DrawioNode の「編集」ボタンクリックを surface でイベント委譲する。
// image_resize.js と同じく editor surface に attach し、図のノードキーを逆引きして
// editor.akebonoEditDrawio(key) を呼ぶ。

function findDrawioKey(editor, figure) {
  let foundKey = null
  editor.getEditorState().read(() => {
    const map = editor.getEditorState()._nodeMap
    for (const [key] of map) {
      if (editor.getElementByKey(key) === figure) { foundKey = key; break }
    }
  })
  return foundKey
}

export function attachDrawioEdit(editor, surface) {
  const onClick = (e) => {
    const btn = e.target.closest("[data-drawio-edit]")
    if (!btn || !surface.contains(btn)) return
    const figure = btn.closest("figure[data-lexical-drawio-node]")
    if (!figure) return
    e.preventDefault()
    e.stopPropagation()
    const key = findDrawioKey(editor, figure)
    if (key && typeof editor.akebonoEditDrawio === "function") {
      editor.akebonoEditDrawio(key)
    }
  }

  surface.addEventListener("click", onClick)
  return () => surface.removeEventListener("click", onClick)
}
